<script>
export let number;
</script>
<div class="col-xl-1 col-md-3">
  <div class="card bg-light mb-4">
    <div class="card-body text-center">
      {number}
    </div>
  </div>
</div>
